import { OnboardingFormFields } from '@Types/index';
import { t } from 'i18next';
import { z } from 'zod';

export const AddressStateSchema = z.object({
  [OnboardingFormFields.STATE]: z
    .object(
      { title: z.string(), value: z.string().min(1) },
      {
        invalid_type_error: t('enErrors:address.state'),
        required_error: t('enErrors:address.state'),
      }
    )
    .required(),
});
